import get from 'lodash/get'

export default (otherFieldPath) => function (value) {
  let otherValue = get(this, otherFieldPath)
  let currentValue = value

  if (otherValue && currentValue) {
    return false
  } else if (!otherValue && !currentValue) {
    return false
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/validators/requiredOneOfTwo.js